import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { REACTIONS } from './reactions';

const fmt = (d) => (d ? new Date(d).toLocaleString('pt-BR') : '-');
export const reactionLabel = (t) => REACTIONS.find((r) => r.tipo === t)?.label || '-';
const slug = (s) => (s || 'comunicado').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 60);

export const employeeRows = (items) => items.map((r) => ({
  Nome: r.nome || '-',
  CPF: r.cpf || '-',
  Matricula: r.matricula || '-',
  Cargo: r.cargo || '-',
  Setor: r.setor || '-',
  Visualizou: r.visualizou ? 'Sim' : 'Não',
  'Data/Hora Visualização': fmt(r.data_leitura),
  Reacao: reactionLabel(r.reacao),
  'Data/Hora Reação': fmt(r.data_reacao),
}));

export const candidateRows = (items) => items.map((r) => ({
  Nome: r.nome || '-',
  Cargo: r.cargo || '-',
  'Data/Hora Visualização': fmt(r.data_leitura),
  Reacao: reactionLabel(r.reacao),
  'Data/Hora Reação': fmt(r.data_reacao),
}));

export const exportExcel = (report, publico, items) => {
  const rows = publico === 'funcionarios' ? employeeRows(items) : candidateRows(items);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), publico === 'funcionarios' ? 'Funcionarios' : 'Candidatos');
  XLSX.writeFile(wb, `engajamento_${publico}_${slug(report.comunicado.titulo)}.xlsx`);
};

export const exportEmployeePdf = (report, items) => {
  const doc = new jsPDF('l', 'mm', 'a4');
  const f = report.funcionarios;
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  let y = 14;
  doc.setFontSize(14);
  doc.text('Relatório de Ciência e Engajamento - Comunicado Interno', 10, y);
  doc.setFontSize(9);
  y += 7;
  doc.text(`Empresa: ${report.empresa || '-'}`, 10, y);
  doc.text(`Gerado em: ${fmt(report.gerado_em)}`, W - 70, y);
  y += 5;
  doc.text(`Comunicado: ${report.comunicado.titulo}`, 10, y);
  y += 5;
  doc.text(`Publicado em: ${fmt(report.comunicado.data_publicacao)}`, 10, y);
  y += 5;
  doc.text(
    `Destinatários: ${f.total_destinatarios}  |  Visualizaram: ${f.visualizaram} (${f.taxa_visualizacao}%)  |  Não visualizaram: ${f.nao_visualizaram}  |  Reagiram: ${f.reagiram} (${f.taxa_engajamento}%)  |  ` +
      REACTIONS.map((r) => `${r.label}: ${f.reacoes[r.tipo] || 0}`).join('  '),
    10, y
  );
  y += 7;
  const cols = [['Nome', 60], ['CPF', 28], ['Cargo', 40], ['Setor', 32], ['Visualizou', 18], ['Data Visualização', 36], ['Reação', 22], ['Data Reação', 36]];
  const header = () => {
    doc.setFillColor(8, 145, 178);
    doc.setTextColor(255);
    doc.rect(10, y - 4, W - 20, 6, 'F');
    let x = 11;
    cols.forEach(([c, w]) => { doc.text(c, x, y); x += w; });
    doc.setTextColor(0);
    y += 6;
  };
  header();
  items.forEach((r, i) => {
    if (y > H - 12) { doc.addPage(); y = 14; header(); }
    if (i % 2) { doc.setFillColor(241, 245, 249); doc.rect(10, y - 4, W - 20, 6, 'F'); }
    const vals = [r.nome, r.cpf, r.cargo, r.setor, r.visualizou ? 'Sim' : 'Não', fmt(r.data_leitura), reactionLabel(r.reacao), fmt(r.data_reacao)];
    let x = 11;
    cols.forEach(([, w], idx) => {
      doc.text(doc.splitTextToSize(String(vals[idx] || '-'), w - 2)[0], x, y);
      x += w;
    });
    y += 6;
  });
  const pages = doc.getNumberOfPages();
  for (let p = 1; p <= pages; p += 1) {
    doc.setPage(p);
    doc.setFontSize(7);
    doc.text(`G2eGente - Registro gerado automaticamente a partir dos acessos ao app. Página ${p}/${pages}`, 10, H - 5);
  }
  doc.save(`engajamento_funcionarios_${slug(report.comunicado.titulo)}.pdf`);
};
